import * as React from "react";
import { useGetAuthQuery } from "../reducers/registerapi";
import Loading from "../components/loading";

const TestAuth = () => {
    const { data, isLoading } = useGetAuthQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="container py-3">
            <h1>Testing Auth</h1>
            <hr />
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
    );
};

export default TestAuth;
